import {
    SHOW_ERROR_MESSAGE,

} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"

export const isPosibleAddNewTeam = (resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/treenode/newteam")
        .then((response) => {
            resolve(response.data.value);
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            resolve();
        });
}

export const addNewTeam = (resolve, reject) => dispatch => {
    new HttpClient(true).post("oga/treenode/add/newteam")
        .then((response) => {
            resolve("Successful");
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            reject("Failed");
        })
}


// WEBPACK FOOTER //
// ./src/reducers/newteam/newteamActions.js